<template>
	<LayoutForm>
        <template slot="header">
            <a href="#" @click.prevent="$router.back()">Back</a>
            <h1>Create Document Category</h1>
        </template>
		<form class="form" @submit.prevent="submit" novalidate>
			<ValidationAlert :error-list="errors.collect('server')" />
			<fieldset class="form__group">
				<div class="form__group">
					<input
                        id="name"
                        class="form__control"
                        type="text"
                        name="name"
                        placeholder="Enter a category name..."
                        v-model="formData.name"
                        v-validate="'required'"
                    />
					<label for="name" class="form__label">Category name</label>
				</div>
                <div class="form__group">
                    <textarea
                        id="description"
                        class="form__control"
                        type="description"
                        name="name"
                        placeholder="Enter a short category description..."
                        v-model="formData.description"
                    />
                    <label for="name" class="form__label">Category Description</label>
                </div>
				<FormControlInsightCategory
                    v-model="formData.parent"
                    label="Select a parent category (optional)"
                    ref="cats"
                    name="parent"
                />
				<FormControlEvent
                    v-model="formData.event"
                    label="Select a related event (optional)"
                    ref="events"
                    :allow-empty="true"
                    name="event"
                />
                <FileUpload
                    id="image"
                    label="Image"
                    v-model="formData.image"
                    name="image"
                    ref="imageUpload"
                    :multiple="false"
                />
				<div class="form__group form__group--submit">
                    <button class="btn btn--primary" v-wait:disabled='"submit"'>
                        <Spinner :height="13" :width="13" v-if="$wait.is('submit')" />
                        <span v-else>Save</span>
                    </button>
				</div>
			</fieldset>
		</form>
	</LayoutForm>
</template>
<script>
	import API from '@api';
	import LayoutForm from '@components/Layout/LayoutForm';
	import FormControlInsightCategory from '@components/Form/Control/FormControlInsightCategory';
	import ValidationAlert from '@components/ValidationAlert';
	import Form from '@components/Form/Form';
    import FileUpload from '@components/Form/FileUpload';
    import Spinner from '@components/Spinner';
    import FormControlEvent from '@components/Form/Control/FormControlEvent';

	export default {
		name: 'InsightCategoryForm',
		mixins: [ Form ],
		components: {
            FormControlEvent,
            Spinner,
            FileUpload,
			ValidationAlert,
			FormControlInsightCategory,
			LayoutForm,
		},
		data() {
			return {
				formData: {
                    name: null,
                    description: null,
                    parent: null,
                    image: null,
                    event: null,
				}
			}
		},
		methods: {
			sanitizeResource(data) {
				return data;
			},
			async submit() {
                const result = await this.$validator.validateAll();

                if(!result || this.$wait.is('submit')) {
                    return false;
                }

                this.$wait.start('submit');

                try {
                    await API.createInsightCategory(this.formData);
                    this.formData = {
                        name: null,
                        description: null,
                        parent: null,
                        image: null,
                        event: null,
                    };
                    this.$refs.imageUpload.clearAll();
                    await this.$refs.events.reset();
                } catch(error) {
                    console.error(error);
                } finally {
                    this.$wait.end('submit');
                }
			}
		},
	}
</script>
